export const GET_DASHBOARD_SHIPMENT_WEIGHT_PROFILE_DATA="GET_DASHBOARD_SHIPMENT_WEIGHT_PROFILE_DATA"
export const GET_DASHBOARD_SHIPMENT_OFD_DATA="GET_DASHBOARD_SHIPMENT_OFD_DATA"
export const GET_DASHBOARD_SHIPMENT_ZONEWISE_DATA="GET_DASHBOARD_SHIPMENT_ZONEWISE_DATA"
export const GET_DASHBOARD_SHIPMENT_OVERVIEW_COURIER_DATA ="GET_DASHBOARD_SHIPMENT_OVERVIEW_COURIER_DATA"
export const GET_DASHBOARD_SHIPMENT_PERFORMANCE_METRIX_DATA ="GET_DASHBOARD_SHIPMENT_PERFORMANCE_METRIX_DATA"

